import ColoredLabelBox from "../../common/ColoredLabelBox";
import { CycleToDatePendingTransaction } from "../../../lib/api/models";
import CycleToDateTransactionsEmptyTable from "../CycleToDateTransactionsEmptyTable";
import { centsToDollarString } from "../../../lib/formatting";
import { format } from "date-fns";
import styles from "./CycleToDateTransactionsPendingTable.module.css";

const strings = {
  status: "Status",
  date: "Date",
  description: "Description",
  auth: "Auth #/POS Entry Mode",
  merchant: "Merchant Category",
  amount: "Amount",
  pending: "Pending",
};

type Props = {
  transactions: CycleToDatePendingTransaction[];
};

export default function CycleToDateTransactionsPendingTable({
  transactions,
}: Props) {
  return (
    <>
      <table className={styles.cycleToDateTransactionsPendingTable}>
        <thead>
          <tr>
            <th>{strings.status}</th>
            <th>{strings.date}</th>
            <th>{strings.description}</th>
            <th>{strings.auth}</th>
            <th>{strings.merchant}</th>
            <th>{strings.amount}</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((t, i) => (
            <tr
              key={t.id}
              className={i % 2 === 1 ? styles.evenRow : styles.oddRow}
            >
              <td>
                <ColoredLabelBox className={styles.status} status="old">
                  {strings.pending}
                </ColoredLabelBox>
              </td>
              <td>{format(new Date(t.date), "MM/dd/yyyy HH:mm:ss")}</td>
              <td>{t.description}</td>
              <td className={styles.authAndPOSContainer}>
                {`${t.authNumber && t.authNumber.length > 0 ? t.authNumber : " "}\n${t.posEntryMode && t.posEntryMode.length > 0 ? t.posEntryMode : " "}`}
              </td>
              <td>{t.merchantCategories}</td>
              <td>{centsToDollarString(t.amountCents)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {transactions.length < 1 ? <CycleToDateTransactionsEmptyTable /> : null}
    </>
  );
}
